import React from "react";

export default function Icon({ name, size, src, ...props }) {
  return (
    <img
      {...props}
      src={src}
      alt={name}
      style={{
        flexShrink: 0,        
        objectFit: "contain",
        ...props.style,                         
        size
      }}
    />
  );
}